<div class="overlay">
  <div class="popup">
    <div class="header">
      <div class="title">
        {{ "export-status.title.exporting" | translate }}...
      </div>
      <div class="close" (click)="cancel()"></div>
    </div>
    <div class="body">
      <p>{{ "export-status.title.exporting" | translate }}...</p>

      <div class="task">
        <app-undetermined-progress-bar
          [height]="'10px'"
        ></app-undetermined-progress-bar>
      </div>
      <sui-button
        variant="danger"
        [leadingIcon]="['fas', 'times']"
        (click)="cancel()"
      >
        {{ "btn.cancel" | translate }}
      </sui-button>
    </div>
  </div>
</div>
